import React from 'react';
import './Carregando.css';
import '../../styles/global.css';

const Carregando = () => {
    return (
        <div className="box-carregando">
            <p className="texto-welcome">Carregando, aguarde...</p>
        </div>
    );
};

export default Carregando;
